import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSortModule } from "@angular/material/sort";
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { QRCodeComponent } from 'angularx-qrcode';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { TisIconComponent } from '@app/components/tis-icon/tis-icon.component';


const uiImports = [
  MatGridListModule,
  MatStepperModule,
  MatTooltipModule,
  MatBottomSheetModule,
  MatMenuModule, MatButtonModule, MatTableModule, CdkTableModule, MatSidenavModule,
  MatTabsModule, MatToolbarModule, MatIconModule, MatDividerModule, MatCardModule,
  MatFormFieldModule, MatRadioModule, MatSelectModule, MatCheckboxModule, MatInputModule,
  MatSnackBarModule, MatDialogModule, MatRippleModule, MatProgressSpinnerModule,
  MatSlideToggleModule, MatListModule, MatDatepickerModule,
  MatPaginatorModule, MatChipsModule, MatExpansionModule,
  LayoutModule, // For Breakpoint Observer,
  ScrollingModule, // For cdk-virtual-scroll
  MatButtonToggleModule,
  MatAutocompleteModule,
  MatBadgeModule,
  MatSortModule,
  MatProgressBarModule,
  ClipboardModule,
  NgxSliderModule,
  TisIconComponent
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ...uiImports,
    QRCodeComponent
  ],
  exports: [
    ...uiImports,
    QRCodeComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class UiModule { }
